<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 md4 lg3 v-for="host in hosts.items" :key="host._id">
        <HostsGridItem :host="host"></HostsGridItem>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HostsGridItem from "./HostsGridItem";

export default {
  name: "HostsGrid",
  props: ["hosts"],
  components: {
    HostsGridItem
  },
  data: function() {
    return {};
  }
};
</script>

<style scoped></style>
